var flatten = require('lodash/flatten');

var flattenDeep = require('lodash/flattenDeep');

var isPlainObject = require('lodash/isPlainObject');

var uniq = require('lodash/uniq');

var uniqWith = require('lodash/uniqWith');

var without = require('lodash/without');

function deleteUndefinedProps(returnObject) {
  // cleanup empty
  for (var prop in returnObject) {
    if (has(returnObject, prop) && isEmptySchema(returnObject[prop])) {
      delete returnObject[prop];
    }
  }

  return returnObject;
}

var allUniqueKeys = function allUniqueKeys(arr) {
  return uniq(flattenDeep(arr.map(keys)));
};

var getValues = function getValues(schemas, key) {
  return schemas.map(function (schema) {
    return schema && schema[key];
  });
};

var has = function has(obj, propName) {
  return Object.prototype.hasOwnProperty.call(obj, propName);
};

var keys = function keys(obj) {
  if (isPlainObject(obj) || Array.isArray(obj)) {
    return Object.keys(obj);
  } else {
    return [];
  }
};

var notUndefined = function notUndefined(val) {
  return val !== undefined;
};

var isSchema = function isSchema(val) {
  return isPlainObject(val) || val === true || val === false;
};

var isEmptySchema = function isEmptySchema(obj) {
  return !keys(obj).length && obj !== false && obj !== true;
};

var withoutArr = function withoutArr(arr) {
  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  return without.apply(null, [arr].concat(flatten(rest)));
};

module.exports = {
  allUniqueKeys: allUniqueKeys,
  deleteUndefinedProps: deleteUndefinedProps,
  getValues: getValues,
  has: has,
  isEmptySchema: isEmptySchema,
  isSchema: isSchema,
  keys: keys,
  notUndefined: notUndefined,
  uniqWith: uniqWith,
  withoutArr: withoutArr
};